const ufeApi = require('services/api/ufeApi');


// https://jira.sephora.com/wiki/display/ILLUMINATE/Add+Shipping+Address+to+Profile+API


function addShippingAddress(input) {
    const url = '/api/users/profiles/address';
    return ufeApi.makeRequest(url, {
        method: 'POST',
        body: JSON.stringify(input)
    }).then(data => data.errorCode ? Promise.reject(data) : data);
}


module.exports = addShippingAddress;
